import { useNavigate } from 'react-router-dom';

import { OrderForm } from '~widgets/order-form';

import Button from '@breeze-platform-ui/button';
import { Int24NavBack } from '@breeze-platform-ui/iconsPack';

import { OrdersLayout } from '../ui/layout';

export const CreateOrderPage = () => {
  const navigate = useNavigate();
  return (
    <OrdersLayout
      title={
        <div className="mb-10 flex w-full items-center gap-6">
          <Button
            size="m"
            icon={<Int24NavBack />}
            theme="mono"
            round
            onClick={() => navigate('/orders')}
          />
          <h2 className="m-0 text-4xl font-bold">Create a new order</h2>
        </div>
      }
    >
      <OrderForm />
    </OrdersLayout>
  );
};
